import React, { useEffect, useRef } from 'react';
import packageInfo from '../package.json';

export const AppVersion = () => {
	const el = useRef<HTMLDivElement>(null);

	useEffect(() => {
		fetch('/spa/online/home/static/js/adviser-online.version')
			.then(response => response.json())
			.then(data => {
				// @ts-ignore
				el.current.outerHTML = appVersion(data.version.split('/').lastItem);
			});
	}, []);

	const { name } = packageInfo;

	const appVersion = (version: string) => {
		return `<!--
            App Name:           ${name}
            Build Version:      ${version}
            React Version:      ${React.version}
-->`;
	};

	return <div ref={el} />;
};
